import LegalLayout, { LegalSection, LegalBullet } from "@/components/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout
      testId="privacy-page"
      eyebrow="your secrets stay in the crypt."
      title="PRIVACY"
      accent="POLICY"
      updated="Last updated: September 2026"
    >
      <LegalSection num="I" title="What We Collect">
        <p>We collect only what we need to run the press:</p>
        <ul className="space-y-2">
          <LegalBullet>
            <strong className="text-bone">Newsletter signups:</strong> your email address, when you
            join the coven.
          </LegalBullet>
          <LegalBullet>
            <strong className="text-bone">Contact messages:</strong> your name, email address, and
            the contents of your message.
          </LegalBullet>
          <LegalBullet>
            <strong className="text-bone">Orders:</strong> your name, email address, and the items
            you purchase.
          </LegalBullet>
          <LegalBullet>
            <strong className="text-bone">Account registration:</strong> your name, email address,
            and a securely hashed password — we never store your actual password.
          </LegalBullet>
          <LegalBullet>
            <strong className="text-bone">Want-list:</strong> the shop items you heart, saved to
            your account.
          </LegalBullet>
          <LegalBullet>
            <strong className="text-bone">Local preferences:</strong> your age-verification status,
            cookie choice, and cart contents, stored in your own browser.
          </LegalBullet>
        </ul>
      </LegalSection>

      <LegalSection num="II" title="How We Use It">
        <ul className="space-y-2">
          <LegalBullet>To send newsletter updates, release announcements, and subscriber offers.</LegalBullet>
          <LegalBullet>To respond to your messages and process your orders.</LegalBullet>
          <LegalBullet>To keep you signed in and to show your want-list and order history.</LegalBullet>
          <LegalBullet>To remember your preferences between visits.</LegalBullet>
          <LegalBullet>To improve the Site and understand what readers love.</LegalBullet>
        </ul>
        <p>
          We do not sell, rent, or trade your personal information to anyone. Ever.
        </p>
      </LegalSection>

      <LegalSection num="III" title="Cookies and Local Storage">
        <p>
          This Site uses browser local storage (a form of cookie) to remember that you passed the
          18+ age gate, your cookie banner choice, and the contents of your shopping cart. If you
          log in to an account, we also set secure, httpOnly session cookies that keep you signed
          in — these cannot be read by other scripts on the page. We do not use third-party
          advertising or tracking cookies. You can clear this data at any time through your browser
          settings; the Site will simply ask you again.
        </p>
      </LegalSection>

      <LegalSection num="IV" title="Third-Party Services">
        <p>
          Some artwork is loaded from our primary website (atrocitycomix.com). If we add payment
          processing or email delivery services in the future, those providers will process only the
          data needed to complete your transaction or deliver your message, under their own privacy
          policies.
        </p>
      </LegalSection>

      <LegalSection num="V" title="Data Retention and Security">
        <p>
          We keep newsletter and contact data for as long as needed to operate the press, and order
          records as required for accounting and legal purposes. We apply reasonable technical and
          organizational measures to protect your information, though no method of transmission or
          storage is perfectly secure.
        </p>
      </LegalSection>

      <LegalSection num="VI" title="Your Rights">
        <ul className="space-y-2">
          <LegalBullet>Request a copy of the personal data we hold about you.</LegalBullet>
          <LegalBullet>Ask us to correct or delete your personal data.</LegalBullet>
          <LegalBullet>Delete your account and its saved want-list.</LegalBullet>
          <LegalBullet>Unsubscribe from the newsletter at any time.</LegalBullet>
          <LegalBullet>Withdraw consent where processing is based on consent.</LegalBullet>
        </ul>
        <p>
          To exercise any of these rights, email{" "}
          <span className="text-bloodglow font-courier">atrocitycomix@atrocitycomix.com</span>.
        </p>
      </LegalSection>

      <LegalSection num="VII" title="Age Restriction">
        <p>
          This Site is intended for adults 18 and over. We do not knowingly collect personal
          information from minors. If you believe a minor has provided us personal information,
          contact us and we will delete it.
        </p>
      </LegalSection>

      <LegalSection num="VIII" title="Changes and Contact">
        <p>
          We may update this policy from time to time; the current version will always live on this
          page with its revision date. Questions about privacy may be sent to{" "}
          <span className="text-bloodglow font-courier">atrocitycomix@atrocitycomix.com</span>.
        </p>
        <p className="font-marker text-bloodglow text-lg rotate-[-1deg] inline-block mt-2">
          — The Atrocity Comix Editorial Team
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
